<template>
  <div class="parent">
    <div class="bg_img" v-if="ishow">
      <div class="login-container">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="账号登录" name="login">
            <el-form :model="accountLoginForm" label-width="40px" class="demo-ruleForm" size="mini" :rules="rules"
                     ref="accountLoginForm">
              <el-form-item label="账号" prop="username" class="account_input">
                <el-input v-model="accountLoginForm.username" placeholder="请输入账号"></el-input>
              </el-form-item>
              <el-form-item label="密码" prop="password" class="account_input">
                <el-input type="password" v-model="accountLoginForm.password" placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item prop="agree">
                <el-checkbox v-model="accountLoginForm.agree">同意</el-checkbox>
                <el-link type="primary" style="margin: -4px 10px 0 10px;" @click="openAgree(1)">用户协议</el-link>
                <el-link type="primary" style="margin-top: -4px;" @click="openAgree(2)">隐私协议</el-link>
              </el-form-item>
              <el-button size="mini" class="registerBtn" type="warning" @click="handleRegister">注册</el-button>
              <el-button size="mini" type="primary" @click="handleAccountLogin('accountLoginForm')">登录</el-button>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="手机登录" name="phone">
            <el-form :model="phoneLoginForm" label-width="70px" class="demo-ruleForm" size="mini" :rules="rulesPhone"
                     ref="phoneLoginForm">
              <el-form-item label="手机号码" prop="phone">
                <el-input v-model="phoneLoginForm.phone" placeholder="请输入手机号码"></el-input>
              </el-form-item>
              <el-form-item label="验证码" class="code_item" prop="code">
                <el-input v-model="phoneLoginForm.code" class="code_input" placeholder="验证码"></el-input>
                <el-button size="mini" type="warning" @click="sendCode('phone')" class="code_btn">{{ code_txt }}
                </el-button>
              </el-form-item>
              <el-form-item prop="agree" class="agree_btn2">
                <el-checkbox v-model="phoneLoginForm.agree">同意</el-checkbox>
                <el-link type="primary"  style="margin: -4px 10px 0 10px;" @click="openAgree(1)">用户协议</el-link>
                <el-link type="primary" style="margin-top: -4px;" @click="openAgree(2)">隐私协议</el-link>
              </el-form-item>
              <el-button size="mini" class="registerBtn" type="warning" @click="handleRegister">注册</el-button>
              <el-button size="mini" type="primary" @click="handlePhoneLogin('phoneLoginForm')">登录</el-button>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div >
    <el-dialog
        v-if="centerDialogVisible"
        :title="title"
        :visible.sync="centerDialogVisible"
        width="100%"
        center>
      <div>鑫游网络游戏用户协议

        本用户协议于2022年1月1日发布实施

        特别说明：

        广州鑫游网络科技有限公司（以下简称“鑫游”，在《文化部网络游戏服务格式化协议必备条款》当中又被称为“甲方”）在此特别提醒用户（经甲方同意，接受甲方提供的网络服务的个人，在《文化部网络游戏服务格式化协议必备条款》当中又被称为“乙方”）仔细阅读本《鑫游网络游戏用户协议》（以下简称“本《用户协议》”）中的各个条款，包括但不限于免除或者限制鑫游责任的条款、对用户权利进行限制的条款以及约定争议解决方式、司法管辖的条款。

        请您仔细阅读本《用户协议》（未成年人应当在其法定监护人陪同下阅读），并选择接受或者不接受本《用户协议》。除非您同意并接受本《用户协议》中的各个条款，否则您无权登录、显示、运行鑫游平台运营的网络游戏（以下简称“网络游戏”、“鑫游网络游戏”），亦无权使用该网络游戏软件的某项功能或某一部分或者以其他的方式使用该游戏软件。您登录、显示、运行鑫游网络游戏，或者使用该网络游戏软件的某项功能、某一部分，或者以其他的方式使用该网络游戏软件的行为，即视为您同意并接受本《用户协议》，愿意接受本《用户协议》各个条款的约束。

        本《用户协议》分为两大部分，第一部分文化部根据《网络游戏管理暂行规定》（文化部令第49号）制定的《网络游戏服务格式化协议必备条款》，第二部分是鑫游根据《中华人民共和国著作权法》、《中华人民共和国合同法》、《著作权行政处罚实施办法》、《网络游戏管理暂行规定》等国家法律法规拟定的《补充协议》；若第一部分与第二部分内容相互冲突时，以第一部分为准。

        第一部分

        网络游戏服务格式化协议必备条款

        根据《网络游戏管理暂行规定》（文化部令第49号），文化部制定《网络游戏服务格式化协议必备条款》。甲方为网络游戏运营企业，乙方为网络游戏用户。

        1.账号注册

        1.1 乙方承诺以其真实身份注册成为甲方的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。

        1.2 乙方以其真实身份注册成为甲方用户后，需要修改所提供的个人身份资料信息的，甲方应当及时、有效地为其提供该项服务。

        2.用户账号使用与保管

        2.1
        根据必备条款的约定，甲方有权审查乙方注册所提供的身份信息是否真实、有效，并应积极地采取技术与管理等合理措施保障用户账号的安全、有效；乙方有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给乙方和他人的民事权利造成损害的，应当承担由此产生的法律责任。

        2.2 乙方对登录后所持账号产生的行为依法享有权利和承担责任。

        2.3 乙方发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据甲方公布的处理方式通知甲方，并有权通知甲方采取措施暂停该账号的登录和使用。

        2.4 甲方根据乙方的通知采取措施暂停乙方账号的登录和使用的，甲方应当要求乙方提供并核实与其注册身份信息相一致的个人有效身份信息。

        2.4.1 甲方核实乙方所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停乙方账号的登录和使用。

        2.4.2 甲方违反2.4.1款项的约定，未及时采取措施暂停乙方账号的登录和使用，因此而给乙方造成损失的，应当承担其相应的法律责任。

        2.4.3 乙方没有提供其个人有效身份证件或者乙方提供的个人有效身份证件与所注册的身份信息不一致的，甲方有权拒绝乙方上述请求。

        2.5 乙方为了维护其合法权益，向甲方提供与所注册的身份信息相一致的个人有效身份信息时，甲方应当为乙方提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。

        3.服务的中止与终止

        3.1 乙方有发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，甲方应当立即终止对乙方提供服务。

        3.2 乙方在接受甲方服务时实施不正当行为的，甲方有权终止对乙方提供服务。该不正当行为的具体情形应当在本协议中有明确约定或属于甲方事先明确告知的应被终止服务的禁止性行为，否则，甲方不得终止对乙方提供服务。

        3.3 乙方提供虚假注册身份信息，或实施违反本协议的行为，甲方有权中止对乙方提供全部或部分服务；甲方采取中止措施应当通知乙方并告知中止期间，中止期间应该是合理的，中止期间届满甲方应当及时恢复对乙方的服务。

        3.4 甲方根据本条约定中止或终止对乙方提供部分或全部服务的，甲方应负举证责任。

        4.用户信息保护

        4.1 甲方要求乙方提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向乙方公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护乙方的个人信息资料的安全。

        4.2 未经乙方许可甲方不得向任何第三方提供、公开或共享乙方注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：

        4.2.1 乙方或乙方监护人授权甲方披露的；

        4.2.2 有关法律要求甲方披露的；

        4.2.3 司法机关或行政机关基于法定程序要求甲方提供的；

        4.2.4 甲方为了维护自己合法权益而向乙方提起诉讼或者仲裁时；

        4.2.5 应乙方监护人的合法要求而提供乙方个人身份信息时。

        第二部分 补充协议

        1、特别提示

        1.1
        鑫游同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务（以下简称“网络服务”），为获得网络服务，服务使用人（以下简称“用户”）同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。这些条款可由鑫游随时更新，本服务协议一旦发生变动，鑫游将会在相关的页面上提示修改内容。修改后的服务协议一旦在页面上公布即有效代替原来的服务协议。用户在使用鑫游提供的各项服务之前，应仔细阅读本服务协议，如用户不同意本服务协议及/或随时对其的修改，请停止使用鑫游提供的服务。

        2、服务内容

        2.1 鑫游网络服务的具体内容由鑫游根据实际情况提供，例如论坛、游戏等。鑫游保留随时变更、中断或终止部分或全部网络服务的权利。

        2.2 鑫游在提供网络服务时，可能会对部分网络服务（例如网络游戏及其他电信增值服务）的用户收取一定的费用。在此情况下，鑫游会在相关页面上做明确的提示。如用户不同意支付该等费用，则可不接受相关的网络服务。

        2.3 用户理解：鑫游仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均应由用户自行负担。

        2.4 用户应使用正版软件接受网络服务。

        3、使用规则

        3.1 用户注册成功后，鑫游将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。

        3.2 用户同意接受鑫游通过电子邮件或其他方式向用户发送的商品促销或其他相关商业信息。

        3.3 用户在使用中文网络游戏网络服务过程中，必须遵循以下原则：

        遵守中国有关的法律和法规；

        不得为任何非法目的而使用网络服务系统；

        遵守所有与网络服务有关的网络协议、规定和程序；

        不得利用鑫游网络游戏网络服务系统进行任何可能对互联网的正常运转造成不利影响的行为；

        不得利用鑫游网络游戏网络服务系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；

        不得利用鑫游网络游戏网络服务系统进行任何不利于鑫游及网络游戏的行为；

        不得利用鑫游网络游戏网络服务系统或QQ、MSN等其他方式对鑫游及网络游戏（包括鑫游独家运行的各款游戏）进行污蔑或攻击，或在鑫游平台上对其他游戏平台进行夸张宣传和恶意拉人等不利于鑫游及网络游戏的行为，或通过对平台进行；

        不得在线下出售、购买鑫游提供的游戏道具等虚拟资产；

        不得使用游戏外挂、或利用游戏程序漏洞获取不正当利益、或进行其他破坏游戏平衡的行为；

        鑫游有权对违反以上规定的用户帐号进行终止服务等处理；终止服务后鑫游对用户投入的时间、金钱不予返还或补偿。若终止服务后用户积极改正过错行为，双方协商一致后鑫游可以继续为用户提供服务。
        就鑫游及合作商业伙伴的服务、产品、业务咨询应采取相应机构提供的沟通渠道，不得在公众场合发布有关鑫游及网络游戏及相关服务的负面宣传。

        如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告鑫游。

        3.4 用户使用根据本协议获得的用户帐号和密码登录鑫游网络游戏的网站或接受其他鑫游提供的服务项目时，应遵守该网站或服务项目的相关服务协议及使用守则，用户登录上述网站或接受上述服务项目时即视为对相关服务协议及使用守则的接受。

        3.5 用户在使用鑫游平台的服务过程中所产生的任何电磁数据的所属权均属于鑫游。

        3.6 用户需要自觉遵守鑫游各网络游戏产品的游戏规则，任何违反游戏规则的行为，用户需要自行承担责任。

        3.7 用户不得影响其他用户正常使用鑫游网络游戏的服务，否则鑫游将有权对用户的资料作出及时的处理。

        3.8 鑫游保留对此部分条款随时增补删除的权利，保留此协议的最终解释权。

        4、所有权及知识产权

        4.1
        本《用户协议》以及下列任何一项作品或资料的所有权及包括著作权在内的全部知识产权均由鑫游享有或鑫游经权利人授权而合法享有其他相关权利，受《中华人民共和国著作权法》、《计算机软件保护条例》、《信息网络传播权保护条例》、《中华人民共和国商标法》和相关的国际条约以及其他的法律法规保护：（1）鑫游网络游戏软件；（2）鑫游网络游戏要素作品（包括但不限于文字、声音、图片、录象、图表等）；鑫游网络游戏数据、鑫游网络游戏过程衍生品、游戏编辑衍生品等。

        4.2
        鑫游基于本《用户协议》许可您的是您对鑫游网络游戏享有非专有使用权。该等非专有使用权，是您对正在使用的网络游戏当前版本所享有的非专有使用权。而且，该等非专有使用权是临时的、可撤销的、本《用户协议》及其补充协议约定范围内的使用权。

        4.3
        本《用户协议》没有也不会将鑫游网络游戏的发行权、信息网络传播权和/或出租权等某一项或某几项著作权权利、及其他的本《用户协议》未明示的权利许可给您，这些权利（或权能）都为鑫游或其他权利人享有。鑫游通过本《用户协议》许可您的，只是通过互联网在线使用和享受鑫游网络游戏产品及服务的权利。

        5、隐私保护

        5.1
        保护用户（特别是未成年人）的隐私是鑫游的一项基本政策，因此，若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用本服务，必须以父母（监护人）名义申请注册，在接受本服务时，应以法定监护人身份加以判断本服务是否符合于未成年人。鑫游保证不对外公开或向第三方
        （5.2所列情况除外）提供用户注册资料及用户在使用网络服务时存储在鑫游的非公开内容，但下列情况除外：

        事先获得用户的明确授权；

        根据有关的法律法规要求；

        按照相关政府主管部门的要求；

        为维护社会公众的利益；

        为维护鑫游的合法权益。

        5.2 鑫游可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与鑫游同等的保护用户隐私的责任，则鑫游可将用户的注册资料等提供给该第三方。

        5.3 在不透露单个用户隐私资料的前提下，鑫游有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。
        尽管鑫游对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。

        6、免责声明

        6.1 鑫游网络游戏通行证所有者不保证以下事宜：

        本服务将符合您的要求；

        本服务将不受干扰、及时提供、安全可靠或不会出错。

        6.2 用户明确同意其使用鑫游网络游戏网络服务所存在的风险将完全由其自己承担；因其使用鑫游网络游戏网络服务而产生的一切后果也由其自己承担，鑫游对用户不承担任何责任。

        6.3 除《网络游戏暂行管理办法》第二十二条规定的情形外，用户尚未使用的网络虚拟货币及尚未失效的游戏服务不予折现或退还。

        6.4
        您充分理解到：网络游戏平台各种不良信息（包括但不限于诈骗、虚假、谩骂、诋毁、侵犯人格权等）、网络安全和网络故障问题，并不是鑫游、合作单位或者网络游戏所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，一概由您自行承担，鑫游和/或合作单位无须向您承担任何责任。

        6.5
        您充分理解到：从第三方获得网络游戏虚拟货币、游戏道具、游戏装备等游戏物品可能存在各种风险。您不得从第三方获得上述游戏物品，您如果坚持从第三方获得上述游戏物品，则您应当自行承担相应的风险，鑫游不保证该等游戏物品在网络游戏能够正常使用，也不保证该等物品不被索回。

        6.6
        鑫游网络游戏和/或其附属的商城内出售的游戏物品，没有标明使用期限，或者其标明的使用期限为“永久”、“无限期”或“无限制”的游戏物品，仅指在鑫游运营网络游戏期间可以无限期使用，其使用期限即为自您获得该游戏物品之日起至鑫游网络游戏终止运营之日止。一旦因为各种原因导致本《用户协议》被终止或者鑫游网络游戏终止运营，您将无法继续使用该等游戏物品，鑫游对您本人或任何第三方均不负任何损害赔偿责任。

        6.7
        您充分理解到：鑫游通过本《用户协议》的方式向您介绍的游戏规则可能是不充分的、有限的。鑫游不保证对网络游戏游戏规则的介绍是完全的、充分的、没有任何错漏的，也不保证网络游戏能够完全地、充分地、没有任何错漏地实现这些游戏规则。

        6.8
        您充分理解到：合作单位在鑫游网络游戏中投放的广告或者进行其他的宣传推广之内容（以下统称“合作单位广告内容”），均是由合作单位自行提供的，网络游戏提供的可能仅仅是链接或者内置服务。您应当通过直接与这些合作单位联系等方式自行判断其真实性，鑫游对合作单位广告内容不作任何明示或者默示的担保。

        6.9
        您充分理解到：合作单位广告内容所对应的商品或服务系由合作单位单独生产或经营的。鑫游没有也不会以分成或者其他任何方式从合作单位销售的该等商品或服务当中取得任何收入，鑫游没有也不会对该等商品或服务之质量作任何明示或者暗示的担保。您如果需要购买该等商品或者消费该等服务，请直接与合作单位联系，自行评估商品或者服务的质量及对价，并自行决定是否要购买或者消费，一概与鑫游无关。

        6.10
        您同意您使用和享受鑫游网络游戏产品及服务是出于您个人意愿，并愿自行承担任何风险及由此给您造成的任何直接、间接、衍生的损害，鑫游不承担任何责任。若依法无法完全排除损害赔偿责任时，鑫游的赔偿责任亦以返还用户因此支付鑫游的价款为限。

        6.11
        您充分理解到：鑫游网络游戏当中可能会设置一些强制要求您与其他用户或者鑫游网络游戏自设的游戏角色进行对战的游戏区域（例如某一服务器或者某一个服务器当中的某一特定游戏区域，亦或是所有的服务器），您如果不同意强制对战，请您立即离开这些游戏区域。如果您没有离开这些游戏区域，即视为您同意强制对战，并接受强制对战在游戏中产生的后果。

        7、服务变更、中断或终止

        7.1 如因系统维护或升级的需要而需暂停网络服务，鑫游将尽可能事先进行通告。

        7.2 如发生下列任何一种情形，鑫游有权随时中止或终止向用户提供本协议项下的网络服务而无需通知用户：

        用户提供的个人资料不真实；

        用户违反本协议中规定的使用规则。

        7.3
        除前款所述情况外，鑫游保留随时地、不事先通知地、不需要任何理由地、单方面地中止履行本《用户协议》及终止本《用户协议》的权利。该等中止、终止，可能是因为鑫游公司解散、注销、合并、分立，也可能是因为鑫游将网络游戏或其运营权转让给了第三方，还可能是因为国家法律、法规、政策及国家机关的命令或者其他的诸如地震、火灾、海啸、台风、罢工、战争等不可抗力事件，还可能是上列原因之外的其他原因。对于所有服务的中断或终止而造成的任何损失，鑫游无需对用户或任何第三方承担任何责任。

        7.4 本《用户协议》如因为本《用户协议》第7.3条所述原因：

        （1）被中止，则包括您在内的所有用户将暂时不能凭借游戏帐号登录网络游戏，直至本《用户协议》中止期限届满之日止；

        （2）被终止，则包括您在内的所有用户将永远不能凭借游戏帐号登录网络游戏，鑫游将以公告或者补充协议的形式处理相关事宜。

        8、违约赔偿

        8.1 用户同意保障和维护中文网络游戏及其他用户的利益，如因用户违反有关法律、法规或本协议项下的任何条款而给鑫游或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。

        8.2 利用程序BUG、恶意程序等非法产出的，一经查实，将受到相应惩罚，并且对非法产出予以清除还原处理，用户将自行承担因此带来的任何损失。最终解释权归鑫游所有，情节严重的鑫游拥有保留追究法律的权益。

        9、法律管辖

        9.1 本协议的订立、执行和解释及争议的解决均应适用中国法律。

        9.2 如双方就本协议内容或其执行发生任何争议，双方应尽量友好协商解决；协商不成时，任何一方均应向鑫游所在地的人民法院提起诉讼。

        10、通知和送达

        10.1 本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。

        11、其他规定

        11.1 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议双方其他权利。

        11.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。

        11.3 本协议中的标题仅为方便而设，不具法律或契约效果。
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">关 闭</el-button>
  </span>
    </el-dialog>
    <div>
      <RealName :show="bind_real_open" @child-real="BindRealNameClick"></RealName>
    </div>
    <div>
      <UserRegister v-if="ishowRegister" @child-register_close="BindRegisterCloseClick"></UserRegister>
    </div>
  </div>
</template>

<script>
import Message from '@/mixins/Message';
import {txPostRequest} from "@/plugins/request";
import {globalStorage} from "@/util/tool";
import RealName from "@/components/ball/RealName.vue"
import UserRegister from "@/components/UserRegister.vue";
export default {
  name: 'UserLogin',
  mixins: [Message],
  components: {UserRegister, RealName},
  data() {
    const validateUsernames = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入账号'));
      } else if (value.length < 8 || value.length > 32) {
        callback(new Error('账号只允许8-32个字符'));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6 || value.length > 32) {
        callback(new Error('密码只允许6-32个字符'));
      } else {
        callback();
      }
    };
    const validatePhone = (rule, value, callback) => {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!phoneRegex.test(value)) {
        callback(new Error('无效的手机号码'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      } else {
        callback();
      }
    };
    const validateAgree = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请勾选协议'));
      } else {
        callback();
      }
    };
    return {
      //定时器对象
      ishow: false,
      Interval: '',
      countDown: 10,
      code_txt: '发送验证码',
      activeName: 'login',
      title: '',
      centerDialogVisible: false,
      bind_real_open:false,
      ishowRegister: false,
      accountLoginForm: {
        username: '',
        password: '',
        agree: false
      },
      rules: {
        username: [
          {validator: validateUsernames, trigger: 'blur'}
        ],
        password: [
          {validator: validatePassword, trigger: 'blur'}
        ],
        agree: [
          {validator: validateAgree, trigger: 'blur'}
        ]
      },
      rulesPhone: {
        phone: [
          {validator: validatePhone, trigger: 'blur'}
        ],
        code: [
          {validator: validateCode, trigger: 'blur'}
        ],
        agree: [
          {validator: validateAgree, trigger: 'blur'}
        ]
      },
      phoneLoginForm: {
        phone: '',
        code: '',
        agree: false
      }
    };
  },
  methods: {
    BindRealNameClick(type,real_success){
      this.bind_real_open=type
      if (real_success){
        globalStorage.set('updateUserParams',{'isShowIframe':true})
      }
    },
    handleRegister() {
      this.ishow = false
      this.ishowRegister = true
    },
    BindRegisterCloseClick() {
      this.ishow = true
      this.ishowRegister = false
    },
    async storageUserInfo(data) {
      let {username,uid,real_name,access_token,qudao_id=1}={...data}
      let info=JSON.stringify( {username,real_name,uid,access_token,qudao_id})
      localStorage.setItem("userInfo", info)
      await this.getGameLink(data)
    },
    handleAccountLogin(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let game_id=globalStorage.get_value('getUserParams','game_id')
           let {code,message,data}  = await txPostRequest(`/user/login/${game_id}`, {
            username: this.accountLoginForm.username,
            password: this.accountLoginForm.password
          }, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          if (code!==0){
            return this.errorMessage(message)
          }
          await this.storageUserInfo(data)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handlePhoneLogin(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let {code,message,data} =await txPostRequest('/sms/login', {username: this.phoneLoginForm.phone, code: this.phoneLoginForm.code})
          if (code!==0){
            return this.errorMessage(message)
          }
          await this.storageUserInfo(data)
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 请求游戏登陆链接
   async getGameLink(dat) {
     globalStorage.set('updateUserParams',{acc:dat.username,access_token:dat.access_token})
     let game_id=globalStorage.get_value('getUserParams','game_id')
     let {code,message,data}  =await txPostRequest('/game/login', {game_id: game_id})
     if (code!==0){
         return this.errorMessage(message)
     }
     let {username,uid,access_token,qudao_id=1}={...dat}
     globalStorage.set('updateReportParams',{username,uid,access_token,qudao_id})
     globalStorage.set('updateUserParams',{'link':data})
     // if (!dat.real_name){
     //   //请先实名
     //   this.bind_real_open=true
     //   return
     // }
     globalStorage.set('updateUserParams',{'isShowIframe':true})
    },
    openAgree(type) {
      if (type === 1) {
        this.title = '用户协议'
      } else {
        this.title = '隐私协议'
      }
      this.centerDialogVisible = true
    },
    sendCode(field) {
      if (this.Interval) {
        return
      }
      let i = 0;
      this.code_txt = (--this.countDown) + "秒再获取"
      // 一顿操作
      this.Interval = setInterval(() => {
        this.countDown--
        this.code_txt = this.countDown + "秒再获取"
        if (!i) {
          this.request_code()
        }
        i++
        if (this.countDown === 0) {
          clearInterval(this.Interval)
          this.countDown = 10
          this.code_txt = '发送验证码'
          this.Interval = ''
        }
      }, 1000)
      this.$refs.phoneLoginForm.validateField(field, (errorMessage) => {
        if (errorMessage) {
          clearInterval(this.Interval)
          this.Interval = ''
          this.countDown = 10
          this.code_txt = '发送验证码'
        }
      });
    },
    request_code() {
      let {code,message} =txPostRequest('/sms/verification_code', {phone: this.phoneLoginForm.phone})
      if (code!==0){
        return this.errorMessage(message)
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  created() {

  },
  mounted() {
    let queryParam = this.$route.query || {}
    // 加载一下
    let username = queryParam.username||'';
    let access_token = queryParam.access_token||'';
    let qudao_id = queryParam.qudao_id||'';
    let uid = queryParam.uid||'';
    let real_name=''
    if (!username || !access_token){
      let store_params=JSON.parse(localStorage.getItem('userInfo'))
      if (store_params){
        username=store_params.username
        access_token=store_params.access_token
        qudao_id=store_params.qudao_id
        uid=store_params.uid
        real_name=store_params.real_name

      }
    }
    if (username && access_token) {
      this.getGameLink({username: username,real_name,uid:uid, access_token: access_token,qudao_id})
    } else {
      this.ishow = true
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 256px;
  margin-left: 20px;
}

.bg_img {
  background-image: url('@/assets/login_bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 280px;
  width: 317px;
}

.parent {
  display: flex; /* 声明为Flex容器 */
  align-items: center; /* 子元素在交叉轴上的对齐方式，这里是垂直居中 */
  justify-content: center; /* 可选，子元素在主轴上的对齐方式，这里是水平居中 */
  height: 100%; /* 指定容器的高度，以便看到垂直居中的效果 */
}

.el-dialog__wrapper >>> .el-dialog {
  margin-top: 0 !important;
}

.el-dialog__wrapper >>> .el-dialog__body {
  height: 500px;
  overflow-y: scroll;
}

.el-tabs >>> .el-tabs__nav {
  margin-left: 27%;
}

.code_btn {
  display: inline-block;
}

.code_input {
  display: inline-block;
  width: 45%;
  padding-right: 6px;

}

.el-tabs >>> .el-tabs__nav-wrap::after {
  height: 0;
}

.el-checkbox >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #2c3e50;
}

.registerBtn {
  margin-left: 30px;
}

.account_input {
  margin-left: 30px;
}

.agree_btn2 {
  margin-left: -30px;
}
</style>
